import * as React from 'react';
import {
	AutocompleteInput,
	BooleanInput,
	Create,
	CreateProps,
	DateInput,
	NumberInput,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import { EGender, ETrainingType } from '../enums';

export const TraineeCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="fullName" label="FULL_NAME"/>
				<UploadImage step={1} source="profileImageUrl" label="PROFILE_IMAGE"/>
				<DateInput step={1} source="birthDate" label="BIRTH_DATE"/>
				<TextInput step={1} source="email" label="EMAIL"/>
				<NumberInput step={1} source="height" label="HEIGHT"/>
				<NumberInput step={1} source="weight" label="WEIGHT"/>
				<SelectInput step={1} source="gender" label="GENDER" choices={Object.keys(EGender).map(key => ({
					id: key,
					name: EGender[key]
				}))}/>
				<SelectInput step={1} source="trainingType" label="TRAINING_TYPE"
				             choices={Object.keys(ETrainingType).map(key => ({
					             id: key,
					             name: ETrainingType[key]
				             }))}/>
				<ReferenceInput
					step={1}
					label="COACH"
					source="coachId" reference="clients"
					alwaysOn
				>
					<AutocompleteInput optionText="fullName"/>
				</ReferenceInput>

				<BooleanInput step={1} source="approvedByCoach" label="APPROVED_BY_COACH"/>
				{/*<BooleanInput step={1} source="shouldReceiveMotivationNotifications"*/}
				{/*              label="SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS"/>*/}
				{/*<BooleanInput step={1} source="shouldReceiveWeightingReminder"*/}
				{/*              label="SHOULD_RECEIVE_WEIGHTING_REMINDER"/>*/}
				{/*<BooleanInput step={1} source="shouldReceiveSendingImageReminder"*/}
				{/*              label="SHOULD_RECEIVE_SENDING_IMAGE_REMINDER"/>*/}
				{/*<BooleanInput step={1} source="shouldCoachReceivePersonalMessagesReminder"*/}
				{/*              label="SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER"/>*/}
				{/*<BooleanInput step={1} source="shouldCoachReceiveTraineesProgressReminder"*/}
				{/*              label="SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER"/>*/}
				{/*<BooleanInput step={1} source="shouldCoachReceiveBirthdayNotifications"*/}
				{/*              label="SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS"/>*/}
				{/*<BooleanInput step={1} source="shouldCoachReceiveNonUploadersReminder"*/}
				{/*              label="SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER"/>*/}
				{/*<TextInput step={1} source="note" label="NOTE"/>*/}
			</SimpleForm>
		</Create>
	);
};
